import { render, staticRenderFns } from "./ManagerList.vue?vue&type=template&id=2fdad711&scoped=true"
import script from "./ManagerList.vue?vue&type=script&lang=js"
export * from "./ManagerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdad711",
  null
  
)

export default component.exports